<app-table [data]="users"
           [config]="tableConfig"
           [isLoading]="isLoading"
           [isMaterial]="false"
           [hasTitle]="hasTitle"
           [headerBackgroundColor]="headerBackgroundColor"
           title="{{'admin.users.title' | translate}}"
           (rowClick)="onRowClick($event)"
           (sortChange)="onSortChange($event)"
           (filterChange)="onFilterChange($event)"
           (pageChange)="onPageChange($event)">
    <app-table-column header="{{'admin.users.table.columns.id' | translate}}"
                      field="id">
    </app-table-column>
    <app-table-column header="{{'admin.users.table.columns.badge' | translate}}"
                      filter="true"
                      sortable="true"
                      field="boschId">
    </app-table-column>
    <app-table-column header="{{'admin.users.table.columns.email' | translate}}"
                      filter="true"
                      sortable="true"
                      field="email">
    </app-table-column>
    <app-table-column header="{{'admin.users.table.columns.userName' | translate}}"
                      filter="true"
                      sortable="true"
                      field="username">
    </app-table-column>
    <app-table-column header="{{'admin.users.table.columns.fullMame' | translate}}"
                      filter="true"
                      sortable="true"
                      field="firstName">
        <ng-template #body
                     let-user="rowData">
            <span>{{ user.fullName }}</span>
        </ng-template>
    </app-table-column>
    <app-table-column header="{{'admin.users.table.columns.userBusinessType' | translate}}"
                      sortable="true"
                      field="userBusinessType">
        <ng-template #filter
                     let-column="column"
                     let-table="table">
            <app-dropdown [(ngModel)]="column.filterValue"
                          [items]="userBusinessTypeFilters"
                          valueField="value"
                          displayField="name"
                          emptyText="{{'admin.users.table.filters.userBusinessType.label' | translate}}"
                          (selectItem)="table.onFilterChange(column)"></app-dropdown>
        </ng-template>
        <ng-template #body
                     let-user="rowData">
            <span>{{ businessTypeLabel(user) | translate }}</span>
        </ng-template>
    </app-table-column>
    <app-table-column header="{{'admin.users.table.columns.status' | translate}}"
                      [sortable]="true"
                      field="isActive">
        <ng-template #filter
                     let-column="column"
                     let-table="table">
            <app-dropdown [(ngModel)]="column.filterValue"
                          [items]="userStates"
                          valueField="value"
                          displayField="name"
                          emptyText="{{'admin.users.table.filters.status.label' | translate}}"
                          (selectItem)="table.onFilterChange(column)"></app-dropdown>
        </ng-template>
        <ng-template #body
                     let-user="rowData">
            <span class="user {{user.isActive ? 'active' : 'inactive'}}">
                {{ (user.isActive ? 'admin.users.table.rows.active' : 'admin.users.table.rows.disabled') | translate }}
            </span>
        </ng-template>
    </app-table-column>
</app-table>
